import { render, staticRenderFns } from "./NotificacionesPage.html?vue&type=template&id=31110592&external"
import script from "./NotificacionesPage.vue?vue&type=script&lang=ts"
export * from "./NotificacionesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports